import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name:"filterCarSearch"
    ,pure: false
})
export class FilterCarSearch implements PipeTransform {
    transform(items : any[],filter:string) {
        if(!items || !filter){
            return items;
        }

        return items.filter((val,idx) => {
            if(val.dtgUnitId.indexOf(filter) > -1){
                return true;
            }
            if(val.dtgCarNo.indexOf(filter) > -1){
                return true;
            }
            return false;
        });
    }
}